import { useEventDataOfSelectedEvent } from "@Utils/event";
import { checkIsArrayEmpty } from "repoV2/utils/common/dataTypes/array";
import { getVariantOptions } from "./utils";

/**
 * @description use this hook in old event page to decide whether to show or hide the `VariantSelector` component shown for merchandise listings
 */
export const useHideVariantSelector = () => {
    const { eventData } = useEventDataOfSelectedEvent();
    const variantOptions = getVariantOptions(
        eventData?.variantsData?.variants_display_data
    );
    return checkIsArrayEmpty(variantOptions);
};
